// lodash throttle dependency - npm
import throttle from 'lodash/throttle'

(function ($) {

  // Plugin definition
  $.fn.toggleOnScroll = function (options) {

    // Extend our default options with those provided.
    // Note that the first argument to extend is an empty
    // object – this is to keep from overriding our "defaults" object.
    var settings = $.extend({}, $.fn.toggleOnScroll.defaults, options);

    // Iterate and reformat each matched element.
    return this.each(function () {

      const elem = $(this);
      let moveElem;
      const scrollPast = elem.data('scroll-height') || settings.scrollHeight;
      const elemScrollHideOn = elem.data('scroll') || settings.scrollHideOn;
      let elemHeight = elem.outerHeight();
      const elemPos = elem.data('position') || settings.scrollPosition;
      let windowScrollDir;
      let scrollPos = 0;
      let cssObj = {
        'transition': 'top 0.3s linear, bottom 0.3s ease, opacity 0.4s ease',
      };
      cssObj[elemPos] = 0; // Should use element.position() instead of 0

      //Setting up moving element based on where setting has been placed.
      if (elem.data('move')) {
        moveElem = $(elem.data('move'))
      } else if (settings.scrollMoveElem) {
        moveElem = $(settings.scrollMoveElem)
      } else {
        moveElem = elem;
      }

      elem.css(cssObj);
      moveElem.css(cssObj);

      elem.css({
        opacity: 1,
      })

      elem.on('click', function () { // accounts for anything that might expand within element
        elemHeight = elem.outerHeight();
      });

      if (
        elemScrollHideOn == 'up'
        && scrollPast && $(window).scrollTop() < scrollPast
        || (scrollPast && $(window).scrollTop() < scrollPast
          && !elemScrollHideOn)) {

        cssObj[elemPos] = '-' + elemHeight + 'px'
        elem
          .css({ opacity: 0 })
        moveElem.css(cssObj);
      }

      window.addEventListener('scroll', throttle(hideElem, 250))

      // This logic could be refactored
      function hideElem() {
        checkScrollDir();
        if (elemScrollHideOn) { // If element has scroll-direction indicated
          if (scrollPast && $(window).scrollTop() > scrollPast) { // If user scrolls past scroll-height
            if (elemScrollHideOn == windowScrollDir) { //if user scrolls in direction element specified
              cssObj[elemPos] = '-' + elemHeight + 'px' // Setting position of object depending on data-position
              elem.css({ opacity: 0 })
              moveElem.css(cssObj);
            } else {
              cssObj[elemPos] = 0
              elem.css({ opacity: 1 })
              moveElem.css(cssObj);
            }
          } else {
            if (elemScrollHideOn == 'up') { //if user scrolls in direction element specified
              cssObj[elemPos] = '-' + elemHeight + 'px' // Setting position of object depending on data-position
              elem.css({ opacity: 0 })
              moveElem.css(cssObj);
            } else {
              cssObj[elemPos] = 0
              elem.css({ opacity: 1 })
              moveElem.css(cssObj);
            }
          }
        } else { // If element does not have scroll direction indicated
          if (elem.data('move')) {
            moveElem = $(elem.data('move'))
          } else if (settings.scrollMoveElem) {
            moveElem = $(settings.scrollMoveElem)
          } else {
            moveElem = elem;
          }
          if (scrollPast && $(window).scrollTop() >= scrollPast) {
            cssObj[elemPos] = 0
            elem.css({ opacity: 1 })
            moveElem.css(cssObj).parent().addClass('drift-shim-up');
          } else {
            cssObj[elemPos] = '-' + elemHeight + 'px'
            elem.css({ opacity: 0 })
            moveElem.css(cssObj).parent().removeClass('drift-shim-up'); // addClass/removeClass is a backup plan - currently because of the #drift-frame-controller component
          }
        }
      }

      function checkScrollDir() {
        var pos2 = $(window).scrollTop();
        var scroll = pos2 > scrollPos ? false : true;
        scrollPos = pos2;

        if (scroll) {
          scroll = 'up';
        } else {
          scroll = 'down'
        }
        windowScrollDir = scroll;
      }
    });
  }

  // Plugin defaults – added as a property on our plugin function.
  $.fn.toggleOnScroll.defaults = {
    scrollHeight: 500,
    scrollPosition: 'bottom',
    scrollHideOn: null,
    scrollMoveElem: null,
  };

  // Applying toggle to utility navbar
  $('#wrapper > header > #header section#2').toggleOnScroll({
    scrollPosition: 'top',
    scrollHideOn: 'down',
    scrollMoveElem: 'body > #wrapper > header',
  });

  // Applying toggle to back-to-top button
  $('.fixed-bottom-right a.btn').toggleOnScroll({
    scrollMoveElem: '#drift-frame-controller, .fixed-bottom-right a.btn'
  });

})(jQuery)